import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const absolutize = (url) => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
};

const normaliseProduct = (p) => ({
  ...p,
  idealUse: p.ideal_use,
  image: absolutize(p.image),
  imageFallback: p.image_fallback,
  image_variants: p.image_variants,
});

export const submitQuote = async (payload) => {
  const res = await axios.post(`${API}/quotes`, payload);
  return res.data;
};

export const fetchProducts = async () => {
  const res = await axios.get(`${API}/products`);
  return (res.data.products || []).map(normaliseProduct);
};

export const fetchProduct = async (id) => {
  const res = await axios.get(`${API}/products/${id}`);
  return normaliseProduct(res.data);
};

export const productSpecPdfUrl = (id) => `${API}/products/${id}/spec.pdf`;
